import { createCaseStudy } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { ...rest } = values;

    return {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
    };
}

export function useCreateCasestudy() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);

            const response = await createCaseStudy({ item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Case Study Created Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
